@if (loaderIcon | async) {
  <app-loader></app-loader>
}
<!--Portal login info modal-->
<div class="modal fade" bsModal #PortalLoginInfoModal="bs-modal" [config]="{ backdrop: 'static', keyboard: false }" id="PortalLoginInfoModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Portal Login Info</h5>
        <button type="button" class="close" aria-label="Close" (click)="cancelPortalLogin(); PortalLoginInfoModal.hide()"
          id="portal-close-button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <app-call-script [section]="section"></app-call-script>
        </div>
        <div class="row mt-3 mx-0 mb-4">
          <form [formGroup]="portalForm" class="NoSidePadding" style="display: inline-flex;gap:10px;">
            <div class="col-md-2 NoSidePadding">
              <label>First Name <span class="required">*</span></label>
              <input class="form-control" type="text" formControlName="FirstName" maxLength="50">

              @if (portalForm.get('FirstName').errors  && (portalForm.get('FirstName').dirty || portalForm.get('FirstName').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (portalForm.get('FirstName').errors.required || portalForm.get('FirstName').errors.pattern) {
                    <span>
                    First Name is required</span>
                  }
                </div>
              }
            </div>
            <div class="col-md-2">
              <label>Last Name <span class="required">*</span></label>
              <input class="form-control" type="text" formControlName="LastName" maxLength="50">

              @if (portalForm.get('LastName').errors  && (portalForm.get('LastName').dirty || portalForm.get('LastName').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (portalForm.get('LastName').errors.required || portalForm.get('LastName').errors.pattern) {
                    <span>
                    Last Name is required</span>
                  }
                </div>
              }
            </div>
            <div class="col-md-4">
              <label>Login ID <span class="required">*</span></label>
              @if (!isFormEdit && !disableForExisting) {
                <input class="form-control" type="text" maxLength="50"
                  formControlName="LoginId" (blur)="isBlurEmailCalled(1)" (keyup)="PortalLoginItemId.next($event)">
              }
              @if (isFormEdit || disableForExisting) {
                <div class="form-control">{{portalForm.get('LoginId').value}}
                </div>
              }

              @if (portalForm.get('LoginId').errors  && (portalForm.get('LoginId').dirty || portalForm.get('LoginId').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (portalForm.get('LoginId').errors.required) {
                    <span>
                      Login Id is required
                    </span>
                  }
                  @if (portalForm.get('LoginId').errors.pattern) {
                    <span>
                      Enter Valid Login Id
                    </span>
                  }
                </div>
              }
              @if (isDuplicateEntry) {
                <div class="alert alert-danger">
                  <span>
                    Login Id already exists
                  </span>
                </div>
              }
            </div>
            <div class="col-md-4">
              <label>Email ID @if (isValidEmail()) {
                <span class="required">*</span>
              }</label>
              @if (!isFormEdit && !disableForExisting) {
                <input class="form-control" type="text"
                  formControlName="EmailId" maxLength="50">
              }
              @if (isFormEdit || disableForExisting) {
                <div class="form-control string_mask_holder">
                {{portalForm.get('EmailId').value}}</div>
              }

              @if (portalForm.get('EmailId').errors  && (portalForm.get('EmailId').dirty || portalForm.get('EmailId').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (portalForm.get('EmailId').errors.pattern) {
                    <span i18n="@@Valid_E-mail">Enter valid E-Mail ID's
                  separated by comma or semi colon</span>
                  }
                  @if (portalForm.get('EmailId').errors.required) {
                    <span>
                    Email Id is required</span>
                  }
                </div>
              }
              @if (isDuplicateEntryEmailId) {
                <div class="alert alert-danger">
                  <span>
                  Email Id already exists</span>
                </div>
              }
            </div>
            <div class="col-md-1">
              @if (isFormEdit) {
                <button [disabled]="!portalForm.valid" class="btn btn-primary ms-3 add_button" style="margin-top: 15px;position: static;"
                type="button" (click)="updatePortalItem()">Update</button>
              }
              @if (!isFormEdit) {
                <button [disabled]="disableADD()" class="btn btn-primary ms-3 add_button"
                style="margin-top: 15px;position: static;" type="button" (click)="addItemToGrid($event)">ADD</button>
              }
            </div>
          </form>

        </div>
        <div class=" col-lg-12">
          <div class="scroll_outer">
            <div class="large_scroll_inner scroll_inner">
              <div id="tableScrollable" class="table_withfilter p-0 border-0">
                <table class="table table-striped text-center mb-0 table-layout-inherit">
                  <colgroup>
                  <col width="5%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="35%">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">
                      <label class="pure-material-checkbox without-text checkbox-hgt">
                        <input type="checkbox" [(ngModel)]="selectAllCheckbox" (click)="selectAllRecords($event)">
                        <span></span>
                      </label>
                    </th>
                    <th scope="col" class="text-start">First Name</th>
                    <th scope="col" class="text-start">Last Name</th>
                    <th scope="col" class="text-start">Login ID</th>
                    <th scope="col" class="text-start">Email ID</th>
                    <th scope="col" class="text-start">Created Date</th>
                  </tr>
                </thead>
              </table>
              <div class="table_withfilter" style="overflow-y: auto;max-height: 400px;">
                <table class="table table-striped text-center mb-0 bg-white table_unsigned">
                  <colgroup>
                  <col width="5%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="20%">
                  <col width="15%">
                </colgroup>
                <tbody class="portal-active">
                  @for (item of portalLoginList; track item) {
                    <tr (click)="editRecord(item, $event)"
                      style="cursor:pointer;">
                      <td class="align-middle">
                        <label class="pure-material-checkbox without-text checkbox-hgt">
                          <input type="checkbox" [(ngModel)]="item.Selected" (change)="onSelectEachRecord()">
                          <span></span>
                        </label>
                      </td>
                      <td class="align-middle" class="text-start">{{item.FirstName}}</td>
                      <td class="align-middle" class="text-start">{{item.LastName}}</td>
                      <td class="align-middle" class="text-start">{{item.UserName}}</td>
                      <td class="align-middle" class="text-start">{{item.EmailId}}</td>
                      <td class="align-middle" class="text-start">{{item.CreatedDateTime  | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
                      <td>
                        <button type="button" class="btn btn-primary" [disabled]="item.NewAccount || disablePasswordReset"
                        (click)="confirmResetPassword()">Reset Password</button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    @if (moduleType == 2) {
      <button type="button" class="btn btn-outline-primary me-3"
      [disabled]="checkIfDelete()" (click)="showDeletePopup()">Delete</button>
    }
    <button type="button" class="btn btn-outline-primary me-3"
    (click)="cancelPortalLogin(); PortalLoginInfoModal.hide()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!portalPageDirty"
    (click)="savePortalLogin(); PortalLoginInfoModal.hide()" id="portal-save-button">Save</button>
  </div>
</div>
</div>
</div>

<!-- Confirmation Modal -->
<div class="modal fade" bsModal #ConfirmationModal="bs-modal" id="ConfirmModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal_600">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Confirm</h5>
        <button type="button" class="close pull-right" aria-label="Close" data-bs-dismiss="modal"
          (click)="ConfirmationModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ptb24">
        <p class="mb-0">
          Are you sure you want to reset the password?
          An email with a temporary password will be sent to the Portal login user.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button" data-bs-dismiss="modal"
        (click)="ConfirmationModal.hide()">NO</button>
        <button class="btn btn-primary px-3" type="button" data-bs-dismiss="modal"
        (click)="portalLoginPasswordReset(); ConfirmationModal.hide();">YES</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete confirm popup -->


<div class="modal fade" bsModal #DeleteAlertModal="bs-modal" id="DeleteModal" tabindex="-1" role="dialog"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal_600">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Delete Portal Login User</h5>
        <button type="button" class="close pull-right" aria-label="Close" data-bs-dismiss="modal"
          (click)="DeleteAlertModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ptb24">
        <p class="mb-0">
          Are you sure you want to delete selected {{recordText}}?
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button"
        (click)="DeleteAlertModal.hide()">NO</button>
        <button type="button px-3" data-bs-dismiss="modal" (click)="deletePortalList()"
        class="btn btn-primary">YES</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #AddAlertModal="bs-modal" id="AddModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal_600">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add</h5>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal" (click)="AddAlertModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row justify-content-center py-3">
          <p>User Account already exists for this {{FieldType}}! Do you want to link it to same account?</p>
        </div>
      </div>
      <div class="modal-footer border-0 text-center">
        <button type="button px-3"
        (click)="clearPortalForm();AddAlertModal.hide()" class="btn btn-primary">NO</button>
        <button type="button px-3" data-bs-dismiss="modal" (click)="updateWithExistingAccData();AddAlertModal.hide()"
        class="btn btn-primary">YES</button>
      </div>
    </div>
  </div>
</div>
